import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

import { RootState } from '@/utils/types';
import { CompanyRegistrationData, Web2LeadCompany } from './company-registration.model';

class CompanyRegistration implements Module<CompanyRegistrationData, RootState> {
  public state: CompanyRegistrationData = {
    salutation: '',
    firstName: '',
    lastName: '',
    legalEntityId: 10,
    company: '',
    email: '',
    numberOfEmployees: '',
    city: '',
    allowedNumberOfEmployees: ['1 - 10'],
  };

  public namespaced: boolean = true;
  public actions = {} as ActionTree<CompanyRegistrationData, RootState>;

  public getters = {
    companyRegistrationData(state: CompanyRegistrationData) {
      return { ...state };
    },
    automatedRegistrationNumberOfEmployees(state: CompanyRegistrationData) {
      return state.allowedNumberOfEmployees;
    },
  } as GetterTree<CompanyRegistrationData, RootState>;

  public mutations = {
    SET_COMPANY_REGISTRATION_DATA(state: CompanyRegistrationData, data: Partial<Web2LeadCompany> & { legalEntityId: number }) {
      const { legalEntityId, companyName, email, firstName, lastName, numberOfEmployees, salutation, city } = data;

      state.salutation = salutation ?? '';
      state.company = companyName ?? '';
      state.legalEntityId = legalEntityId;
      state.email = email ?? '';
      state.firstName = firstName ?? '';
      state.lastName = lastName ?? '';
      state.numberOfEmployees = numberOfEmployees ?? '';
      state.city = city ?? '';
    },
  } as MutationTree<CompanyRegistrationData>;
}

export default new CompanyRegistration();
